export function gxlCookie(name: string, value: string, maxAge: number): string {
  const parts = [`${name}=${value}`, "path=/"];
  if (location.hostname.endsWith(".gxl.ai")) {
    parts.push("Domain=.gxl.ai", "SameSite=Lax");
  } else {
    parts.push("SameSite=Strict");
  }
  if (location.protocol === "https:") parts.push("Secure");
  parts.push(`max-age=${maxAge}`);
  return parts.join("; ");
}

/** True if the legacy JavaScript-readable authentication cookie is present. */
export function hasGxlAuthCookie(): boolean {
  const m = document.cookie.match(/(?:^|;\s*)gxl_auth=([^;]*)/);
  return m !== null && m[1].length > 0;
}

export function clearGxlAuthCookie(): void {
  // The durable gxl_session cookie is HttpOnly and is cleared by the server.
  document.cookie = gxlCookie("gxl_auth", "", 0);
}
